import { z } from 'zod'
import { oc } from '@orpc/contract'

export const recordLocationsGet = oc
  .route({ method: 'GET', path: '/v2/facility/record-locations' })
  .input(z.object({ patientId: z.string() }))
  .output(
    z.object({
      // Deduped-by-name places the patient has been (their FHIR Locations,
      // e.g. imported from HealthGorilla) — used for "been here" indicators
      // and name suggestions in the records-request facility UX.
      locations: z.array(
        z.object({
          name: z.string(),
          address: z.string().optional(),
          street: z.string().optional(),
          city: z.string().optional(),
          state: z.string().optional(),
          zip: z.string().optional(),
          phone: z.string().optional(),
        }),
      ),
    }),
  )
